export default __webpack_public_path__ + "static/inner-belief_cover-big-9293096374a293c5f91347a8b3d96372.webp";